import React, { useCallback, useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LayersIcon from '@material-ui/icons/Layers';
import HomeIcon from '@material-ui/icons/Home';
import SettingsIcon from '@material-ui/icons/Settings';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Divider from '@material-ui/core/Divider';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import {checkUserAdminRole} from "./RestService";

import { ClickAwayListener, Collapse, Icon, makeStyles } from '@material-ui/core';
import { AssignmentTurnedIn, CheckBox, ExpandLess, ExpandMore, PlaylistAddCheck, ShowChart } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import CryptoJS from "crypto-js";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
  imageIcon: {
    height: '100%'
  },
  iconRoot: {
    textAlign: 'center'
  }
}));

export default function SelectedListItem(props) {
  const {instance} = useMsal();
  const classes = useStyles();
  const indexHandler = props.indexHandler;
  const titleHandler = props.titleHandler;
  const pathHandler = props.pathHandler;
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedAdminItem, setSelectedAdminItem] = useState("");
  const [openProduction, setOpenProduction] = React.useState(false);
  const [openCWS, setOpenCWS] = React.useState(false);
  const [validationIn, setValidationIn] = useState(true);
  const [adminIn, setAdminIn] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const [checkAdminRole, setCheckAdminRole] = useState(false);
  
  let secretKey = sessionStorage.getItem("pdmUsername")+"AxZ4p"+sessionStorage.getItem("pdmPassword")+"2KlEd";

  const handleClickCWS = () => {
    setOpenCWS(!openCWS);
  };

  const handleClickAway = () => {
    setSelectedItem("");
  };

  const handleAdminClickAway = () => {
    setSelectedAdminItem("");
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    indexHandler(index, "", "");
    if (index == 0) {
      history.push("/");
    }
    else if (index == 2) {
      history.push("/batches");
    }
    else if (index == 6) {
      history.push("/datavalidation");
    }
    else if (index == 7) {
      history.push("/bomcompare");
    }
    else if (index == 8) {
      history.push("/admintools");
    }
    else if (index == 9) {
      history.push("/adminarchive");
    }
  };

  useEffect(() => {
    checkUserRole();
  }, []);

  const checkUserRole = async () => {
    const oldStatus=sessionStorage.getItem("statusValue");
    var status = "";
    if(oldStatus!==null && oldStatus.trim()!=="" && oldStatus.trim()!=="null")
    {
      console.log("Not hitting API");
      const bytes = CryptoJS.AES.decrypt(oldStatus, secretKey);
      status = bytes.toString(CryptoJS.enc.Utf8);
    }
    else
    {
      console.log("Hitting API");
      status = await checkUserAdminRole(instance);
      const encrypted = CryptoJS.AES.encrypt(status, secretKey).toString();
      sessionStorage.setItem("statusValue", encrypted);
    }
    if(status=="1")
    {
      setCheckAdminRole(true);
    }
    else
    {
      setCheckAdminRole(false);
    }
  }

  useEffect(() => {
    setSelectedIndex(0);

    indexHandler(0);
    titleHandler(["Production"]);
    pathHandler("");
  }, [props.homeHandler]);

  useEffect(() => {
    if (location["pathname"] == "/batches" || location["pathname"] == "/batch") {
      setSelectedIndex(2);
    }
    else if (location["pathname"] == "/datavalidation" || location["pathname"] == "/datavalidation/edit") {
      setSelectedIndex(6);
    }
    else if (location["pathname"] == "/bomcompare" || location["pathname"] == "/bomcompare/edit") {
      setSelectedIndex(7);
    }
    else if (location["pathname"] == "/admintools") {
      const oldStatus=sessionStorage.getItem("statusValue");
      const bytes = CryptoJS.AES.decrypt(oldStatus, secretKey);
      const status = bytes.toString(CryptoJS.enc.Utf8);
      if(status=="1")
      {
        setSelectedIndex(8);
      }
      else
      {
        setSelectedIndex(0);
        history.push("/");
      }
    }
    else if (location["pathname"] == "/adminarchive") {
      setSelectedIndex(9);
    }

    if (location["pathname"] == "/bomcompare" || location["pathname"] == "/datavalidation"
    || location["pathname"] == "/bomcompare/edit" || location["pathname"] == "/datavalidation/edit"){
      setValidationIn(true);
      if(selectedItem != "Validation"){
        setSelectedItem("Validation");
      }
    }
    else
    {
      setValidationIn(false);
    }

    if (location["pathname"] == "/admintools" || location["pathname"] == "/adminarchive"){
      setAdminIn(false);
      if(selectedAdminItem != "Admin"){
        setSelectedAdminItem("Admin");
      }
    }
    else
    {
      setAdminIn(true);
    }
  }, [location]);

  return (
    <div>
      <List>
      <ListItem
          button
          selected={selectedIndex === 0}
          onClick={(event) => {
            handleListItemClick(event, 0)
          }
          }
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        
        <ListItem
          button
          selected={selectedIndex === 2}
          onClick={(event) => {
            handleListItemClick(event, 2)
          }
          }
        >
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="My batches" />
        </ListItem>

        <ClickAwayListener onClickAway={handleClickAway}>
          <div>
            <ListItem
              button
              selected={selectedIndex === 5}
              onClick={() => {
                setValidationIn(prev => !prev);
                setSelectedItem(prev =>
                  prev === "Validation" ? "" : "Validation"
                );
              }}
            >
              <ListItemIcon>
                <CheckBox />
              </ListItemIcon>
              <ListItemText primary="Validation" />
              <ListItemIcon>
                {validationIn ? <ExpandLess /> : <ExpandMore />}
              </ListItemIcon>
            </ListItem>

            <Collapse in={validationIn} unmountOnExit>
              <ListItem
                button
                selected={selectedIndex === 6}
                className={classes.nested}
                onClick={(event) => {
                  setSelectedItem("DataValidation");
                  handleListItemClick(event, 6);
                }}
              >
                <ListItemIcon>
                  <AssignmentTurnedIn />
                </ListItemIcon>
                <ListItemText primary="Data validation" />
              </ListItem>

              <ListItem
                button
                selected={selectedIndex === 7}
                className={classes.nested}
                onClick={(event) => {
                  setSelectedItem("BOMCompare");
                  handleListItemClick(event, 7);
                }}
              >
                <ListItemIcon>
                  <PlaylistAddCheck />
                </ListItemIcon>
                <ListItemText primary="BOM compare" />
              </ListItem>
            </Collapse>
          </div>
        </ClickAwayListener>

        {checkAdminRole &&
        <ClickAwayListener onClickAway={handleAdminClickAway}>
        
        <ListItem
          button
          selected={selectedIndex === 10}
          onClick={(event) => {
            // handleListItemClick(event, 5);
            // handleClickCWS();
            setAdminIn(!adminIn);
            if (selectedAdminItem == "Admin")
            {
              setSelectedAdminItem("");
            } else 
            {
              setSelectedAdminItem("Admin");
            }
          }
        }
        >
          <ListItemIcon>
            <CheckBox />
          </ListItemIcon>
          <ListItemText primary="Admin" />
          {(adminIn) ? 
          <ListItemIcon><ExpandMore /></ListItemIcon> : 
          <ListItemIcon><ExpandLess /></ListItemIcon>}
        </ListItem>
        </ClickAwayListener>}
        {checkAdminRole &&
        <Collapse unmountOnExit in={!adminIn}> 
        <ListItem
          button
          selected={selectedIndex === 8}
          className={classes.nested}
          onClick={(event) => {
            setSelectedAdminItem("Tools");
            handleListItemClick(event, 8);
            event.stopPropagation();
          }
        }
        >
          <ListItemIcon>
            <AssignmentTurnedIn />
          </ListItemIcon>
          <ListItemText primary="Tools" />         
        </ListItem>

        <ListItem
          button
          selected={selectedIndex === 9}
          className={classes.nested}
          onClick={(event) => {
            setSelectedAdminItem("Archive");
            handleListItemClick(event, 9);
            event.stopPropagation();
          }
        }
        >
          <ListItemIcon>
            <PlaylistAddCheck />
          </ListItemIcon>
          <ListItemText primary="Archive" />
        </ListItem>
        </Collapse>}
        {/* <ListItem
          button
          selected={selectedIndex === 3}
          onClick={(event) => {
            handleListItemClick(event, 3)
            handleClickCWS()
          }
          }
        >
          <ListItemIcon>
            <LayersIcon />
          </ListItemIcon>
          <ListItemText primary="Test order templates" />
        </ListItem> */}

        {/* <ListItem
          button
          selected={selectedIndex === 4}
          onClick={(event) => {
            handleListItemClick(event, 4)
          }
          }
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </ListItem> */}
      </List>
      <Divider />
    </div>
  );
}